import React from 'react'
import { withIcon } from '../../withIcon'

function PlaylistEmptyIcon (props) {
  const {
    size = '20px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path d="M10 10H2.5" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.3333 5H2.5" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 15H2.5" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.332 10L17.4987 12.5L13.332 15V10Z" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default withIcon(PlaylistEmptyIcon)
